import * as React from "react"
import * as vm from "../viewmodel/prislister"
import { Prisliste } from "../viewmodel/prisliste"

// GetFromUrl - for loading of json files
function GetFromUrlold(yourUrl: string) {
    var Httpreq = new XMLHttpRequest(); // a new request
    Httpreq.open("GET", yourUrl, false);
    Httpreq.send(null);
    return Httpreq.responseText;
}

/* Prislister Draws and handles interaction with the dropdown list where the user can
 * select a prize book. The handler for item selections is changePricelist, which will
 * examine the selected item and send forward the event to changePricelist within App.
 * For this process, the two interfaces prisliste and prislister are being used.  */
export class Prislister extends React.Component<vm.Prislister, {}> {
    constructor(p:vm.Prislister) {
        super(p)
        this.m_selectedID = this.props.selectedID
    }
    
    private changePricelist(e: React.FormEvent<HTMLSelectElement>) {
        var target = e.currentTarget;
        var index = target.selectedIndex;

        this.props.changeHandler(index)
    };

    render() {
        // Reads the list items from the selectOptions.json file and returns a renderable listbox.
        var pos = 0
        var contents = null
        const selID = this.m_selectedID

        var core = this.props.app.GetCore()
        
        var selectedIndex = core.GetSelectedPriceBookIndex()

        if (selID == -1) {
            selectedIndex = core.GetPriceBooks().length
        }

        var defaultValue = ""
        
        if (this.props.contentString != null) {
            contents = JSON.parse(this.props.contentString).map(function (item: { shownText: string, fileBase: string }) {
                const keyIndex = pos++ // react items within an array must have a unique key value, which is this incremented keyIndex
                if (keyIndex == selectedIndex) {
                    defaultValue = item.fileBase
                }
                return <option key={keyIndex} value={item.fileBase}>{item.shownText}</option>
            })
        }
        
        if (contents != null) {
            if (contents.length > 0) {
                return <div onClick={this.BreakFocus.bind(this)} >
                    <select defaultValue={defaultValue} onChange={e => this.changePricelist(e)} style={{ height: '25px', marginLeft: '8px', marginTop: '5px' }}>{
                        contents
                    }
                    </select>
                </div>;
            }
        }

        return <div style={{ position: "relative", top: "9px", color: "#770000", marginLeft: "10px", marginRight: "10px", fontSize: "12.5px" }}>{"<Ingen prisbok innført>"}</div>
    }

    BreakFocus() {
        this.props.app.BreakFocus()
    }

    public GetSelectedID() {
        return this.m_selectedID
    }
    
    public SetSelectedID(id: number) {
        this.m_selectedID = id
    }

    private m_selectedID : number
}


// WEBPACK FOOTER //
// ./client/view/prislister.tsx